// extracted by mini-css-extract-plugin
export default {"styles":"styles___E66Fl","FFeather":"FFeather___yKP79"};